import { Delete, TableChart } from '@mui/icons-material'
import { Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { GridToolbar } from '../../../../components/GridToolbar/GridToolbar'
import { showErrorToast, showWarningToast } from "../../../../constToast/constToast";
import IconButton from "@mui/material/IconButton";

export default function SupDataGrid({ item, onChange, onSave }) {
  const [open, setOpen] = useState(false)

  const deleteRow = params => {
    const newData = item?.gridDatas?.map(item => {
      return {
        ...item,
        type: params.id === item.id ? 2 : item?.type
      }
    })
    onChange(newData)
  }

  const columns = item?.gridColumns?.length > 0 ? item?.gridColumns?.map((name, index) => ({
    field: `column${index + 1}`,
    headerName: name,
    width: 150,
    headerAlign: 'center',
    align: 'center',
    editable: true
  })) : []

  if (columns.length && item.designId !== 46) {
    columns.unshift({
      headerName: 'Actions',
      field: 'actions',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      renderCell: (params) => (
        <IconButton onClick={() => deleteRow(params)} sx={{ p: 0 }}>
          <Delete style={{ color: 'red', marginRight: 3 }} />
        </IconButton>
      ),
    },)
  }

  const columnsArr = []
  const obj = {}
  item?.gridColumns?.forEach((_, index) => {
    obj[`column${index + 1}`] = ''
    columnsArr.push(`column${index + 1}`)
  })

  const rows = item?.gridColumns?.length > 0 ? item?.gridDatas?.filter(x => x?.type !== 2) : []

  const handleClose = () => {

    if (item.designId === 46) {
      const allFilled = item.gridDatas.every(row => columnsArr.every(x => row?.[x]));

      if (allFilled) {
        setOpen(false);
      } else {
        // showWarningToast('Please type all');
        setOpen(false);
      }

      onChange(item?.gridDatas?.filter(item => columnsArr.some(x => item?.[x])))
    } else {
      onChange(item?.gridDatas?.filter(item => columnsArr.some(x => item?.[x])))
      setOpen(false);
    }

  }

  // Add Method

  const handleAddRow = () => {

    const lastElement = item?.gridDatas?.[item?.gridDatas?.length - 1]

    if (item?.gridDatas?.length > 0 && !columnsArr.some(x => lastElement?.[x])) {
      return showErrorToast('Please type something')
    }

    onChange([...item?.gridDatas, {
      id: generateRandomIntegerGreaterThanZero(),
      ...obj
    }])
  };

  const onCellEditCommit = (data) => {
    const newData = [...rows]
    const index = newData?.findIndex(item => item?.id === data?.id)
    newData[index] = {
      ...newData[index],
      [data?.field]: data?.value
    }
    onChange(newData)
  }

  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (onSave) {
      setTouched(true);
    } else {
      setTouched(false);
    }

  }, [onSave]);

  const showError = (item.isMandatory && touched && rows.length === 0) || (touched && rows.length === 0 && item.hasRadioBox && item.radioboxValue);

  return (
    <>
      <Badge badgeContent={item?.gridDatas?.filter(item => item?.type != 2)?.length} color="error">
        <Button size='small'
          onClick={() => setOpen(true)}
          variant='contained' endIcon={
            <TableChart />
          }>
          DataGrid
        </Button>
      </Badge>

      <div>
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
            Evaluation Grid
          </DialogTitle>
          <Divider />

          <DialogContent>
            <Box sx={{ height: 300, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                getRowId={row => row.id}
                rowHeight={35}
                onCellEditCommit={onCellEditCommit}
                // onRowDoubleClick={handleDoubleClick}
                showCellRightBorder
                components={{
                  Toolbar: () => (
                    <GridToolbar
                      hiddenSearch={true}
                      hiddenRefresh={true}
                      hiddenColumn={true}
                      hiddenFilter={true}
                      hiddenSize={true}
                      hiddenExport={true}
                      handleAddRow={handleAddRow}
                      hiddenContent={item.designId === 46 ? true : false}
                    />
                  ),
                }}
              />
            </Box>

          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Box>
              {/* <Button onClick={handleSubmit(onSubmit)} variant='contained'>Save</Button> */}
              <Button onClick={handleClose}>Save</Button>
            </Box>
          </DialogActions>
        </Dialog>

      </div>
      {showError ? <span style={{ color: '#d32f2f' }}>This field is required</span> : <></>}
    </>
  )
}


function generateRandomIntegerGreaterThanZero() {
  return -Math.floor(Math.random() * 2147483646) + 1;
}
